var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaskGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 153,
    viewBox: "0 0 151 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 150C116.921 150 150.5 116.421 150.5 75C150.5 33.5786 116.921 0 75.5 0C34.0786 0 0.5 33.5786 0.5 75C0.5 116.421 34.0786 150 75.5 150Z",
    fill: "url(#paint0_linear_573_15576)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_573_15576)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_573_15576",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 151,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 150C116.921 150 150.5 116.421 150.5 75C150.5 33.5786 116.921 0 75.5 0C34.0786 0 0.5 33.5786 0.5 75C0.5 116.421 34.0786 150 75.5 150Z",
    fill: "url(#paint1_linear_573_15576)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_573_15576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.5 43H32.5C29.7386 43 27.5 45.2386 27.5 48V153C27.5 155.761 29.7386 158 32.5 158H118.5C121.261 158 123.5 155.761 123.5 153V48C123.5 45.2386 121.261 43 118.5 43Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 53H40.5C38.8431 53 37.5 54.3431 37.5 56C37.5 57.6569 38.8431 59 40.5 59H66.5C68.1569 59 69.5 57.6569 69.5 56C69.5 54.3431 68.1569 53 66.5 53Z",
    fill: "#E1EBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 95H40.5C38.8431 95 37.5 96.3431 37.5 98C37.5 99.6569 38.8431 101 40.5 101H66.5C68.1569 101 69.5 99.6569 69.5 98C69.5 96.3431 68.1569 95 66.5 95Z",
    fill: "#E1EBFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 68H42.5C40.2909 68 38.5 69.7909 38.5 72V82C38.5 84.2091 40.2909 86 42.5 86H108.5C110.709 86 112.5 84.2091 112.5 82V72C112.5 69.7909 110.709 68 108.5 68Z",
    stroke: "#17428B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 109H42.5C39.7386 109 37.5 111.239 37.5 114V122C37.5 124.761 39.7386 127 42.5 127H108.5C111.261 127 113.5 124.761 113.5 122V114C113.5 111.239 111.261 109 108.5 109Z",
    fill: "#DFEAFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 32C55.7091 32 57.5 30.2091 57.5 28C57.5 25.7909 55.7091 24 53.5 24C51.2909 24 49.5 25.7909 49.5 28C49.5 30.2091 51.2909 32 53.5 32Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 32C77.7091 32 79.5 30.2091 79.5 28C79.5 25.7909 77.7091 24 75.5 24C73.2909 24 71.5 25.7909 71.5 28C71.5 30.2091 73.2909 32 75.5 32Z",
    fill: "#17428B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 32C99.7091 32 101.5 30.2091 101.5 28C101.5 25.7909 99.7091 24 97.5 24C95.2909 24 93.5 25.7909 93.5 28C93.5 30.2091 95.2909 32 97.5 32Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 88C89.2614 88 91.5 85.7614 91.5 83C91.5 80.2386 89.2614 78 86.5 78C83.7386 78 81.5 80.2386 81.5 83C81.5 85.7614 83.7386 88 86.5 88Z",
    fill: "#DFEAFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.407 104.37C89.607 104.37 88.86 104.37 88.18 104.327C87.3424 104.27 86.5366 103.984 85.8514 103.499C85.1661 103.014 84.6279 102.349 84.296 101.578L80.077 93.2399C79.7675 92.8796 79.613 92.4116 79.6471 91.9379C79.6812 91.4642 79.9011 91.0232 80.259 90.7109C80.5521 90.4753 80.9178 90.3484 81.294 90.3519C81.5709 90.3599 81.8427 90.428 82.0908 90.5512C82.3389 90.6745 82.5573 90.8501 82.731 91.0659L84.647 93.6809L84.676 93.7149V83.7799C84.676 83.287 84.8718 82.8143 85.2203 82.4657C85.5688 82.1172 86.0416 81.9214 86.5345 81.9214C87.0274 81.9214 87.5001 82.1172 87.8486 82.4657C88.1972 82.8143 88.393 83.287 88.393 83.7799V90.2799C88.3714 90.0407 88.3999 89.7996 88.4766 89.5721C88.5533 89.3445 88.6766 89.1354 88.8386 88.9581C89.0006 88.7808 89.1978 88.6392 89.4175 88.5424C89.6373 88.4455 89.8748 88.3955 90.115 88.3955C90.3551 88.3955 90.5926 88.4455 90.8124 88.5424C91.0321 88.6392 91.2293 88.7808 91.3913 88.9581C91.5533 89.1354 91.6766 89.3445 91.7533 89.5721C91.8301 89.7996 91.8585 90.0407 91.837 90.2799V91.6349C91.8154 91.3957 91.8439 91.1546 91.9206 90.9271C91.9973 90.6995 92.1206 90.4904 92.2826 90.3131C92.4446 90.1358 92.6418 89.9942 92.8615 89.8974C93.0813 89.8005 93.3188 89.7505 93.559 89.7505C93.7991 89.7505 94.0366 89.8005 94.2564 89.8974C94.4761 89.9942 94.6733 90.1358 94.8353 90.3131C94.9973 90.4904 95.1206 90.6995 95.1973 90.9271C95.2741 91.1546 95.3025 91.3957 95.281 91.6349V92.6789C95.2594 92.4397 95.2879 92.1986 95.3646 91.9711C95.4413 91.7435 95.5646 91.5344 95.7266 91.3571C95.8886 91.1798 96.0858 91.0382 96.3055 90.9414C96.5253 90.8445 96.7628 90.7945 97.003 90.7945C97.2431 90.7945 97.4806 90.8445 97.7004 90.9414C97.9201 91.0382 98.1173 91.1798 98.2793 91.3571C98.4413 91.5344 98.5646 91.7435 98.6413 91.9711C98.7181 92.1986 98.7465 92.4397 98.725 92.6789V99.0159C98.691 100.965 97.81 104.251 94.711 104.251C94.486 104.261 92.58 104.371 90.411 104.371L90.407 104.37Z",
    fill: "#17428B",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_573_15576",
    x: 21.5,
    y: 34,
    width: 108,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_15576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_15576",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_573_15576",
    x1: 75.5,
    y1: 0,
    x2: 75.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_573_15576",
    x1: 75.5,
    y1: 0,
    x2: 75.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup);
export default __webpack_public_path__ + "static/media/MaskGroup.aadf9ab50bab71dae0c7237b7619bc6c.svg";
export { ForwardRef as ReactComponent };